import { render, staticRenderFns } from "./notificaciones-oeb-prodplan.vue?vue&type=template&id=e007853c&scoped=true"
import script from "./notificaciones-oeb-prodplan.vue?vue&type=script&lang=js"
export * from "./notificaciones-oeb-prodplan.vue?vue&type=script&lang=js"
import style0 from "./notificaciones-oeb-prodplan.vue?vue&type=style&index=0&id=e007853c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e007853c",
  null
  
)

export default component.exports